$('.toggle-input').on('click', function() {
    if ($(this).hasClass('toggle-input-active')){
        $(this).removeClass('toggle-input-active');
    } else {
        $(this).addClass('toggle-input-active');
        $('.toggle-input-active').not(this).removeClass('toggle-input-active');
    }

    if ($(this).parents().find('.no-bg-header').length){
        $(this).parents('.main-header').removeClass('header-dark');
        $(this).parents('.main-header').addClass('header-light');
    }
    
    if(($('.toggle-input-active').length < 1) && ($(this).parents().find('.no-bg-header').length)){
        $(this).parents('.main-header').addClass('header-dark');
        $(this).parents('.main-header').removeClass('header-light');
    }
});

$('#mobileNavOpen').on('click', function() {
    $('.nav-primary').toggleClass('display-none');
	$('#nav-icon3').toggleClass('open');
});